import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const classExists = document.getElementsByClassName("accordion-product").length > 0;
const mq = gsap.matchMedia();

if (classExists) {

  mq.add("(min-width: 1280px)", () => {

    const buttons = document.querySelectorAll('.accordion-product__menu .menu-btn');

    // Add active class to first button
    buttons[0].classList.add('active');

    buttons.forEach((button) => {

      button.addEventListener('click', () => {

        // Define fixed offset in PX
        const fixedOffset = 192;

        // Get the target ID from the data-target attribute
        const targetId = button.getAttribute('data-item');

        // Find the target element by its ID
        const targetElement = document.getElementById(targetId);

        if (targetElement) {

          const offset = targetElement.getBoundingClientRect().top;
          const scrollPosition = window.scrollY + offset - fixedOffset;

          // Scroll to the target element with the calculated scroll position
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
          });

        }
      });

    });

    const accordionItems = document.querySelectorAll('.accordion-product__item');

    accordionItems.forEach((item, index) => {

      const image = item.querySelector('.accordion-product__image');

      // Using data-item attribute from button to match the accordion item ID
      const associatedButton = document.querySelector(`.menu-btn[data-item="${item.id}"]`);

      // Define the animation for each image
      const fadeAccordionImage = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top +=500',
          end: 'top +=100',
          scrub: true,
          markers: false,
          onEnter: () => {
            buttons.forEach((btn) => {
              btn.classList.remove('active');
            });
            associatedButton.classList.add('active');
          },
          onEnterBack: () => {
            buttons.forEach((btn) => {
              btn.classList.remove('active');
            });
            associatedButton.classList.add('active');
          },
        },
      });

      // Add the animation to fade in each image
      fadeAccordionImage.fromTo(
        image,
        { opacity: index === 0 ? 1 : 0 },
        { opacity: 1, duration: 0.3 }
      );

      // Hide the previous item as the next one fades in (except for the first item)
      if (index > 0) {
        const previousItem = accordionItems[index - 1];
        const previousImage = previousItem.querySelector('.accordion-product__image');
        fadeAccordionImage.to(previousImage, { opacity: 0, duration: 0.3 }, '<');
      }

    });

  });

}